
    import { Observable } from 'rxjs';
    import { UseCase } from '../../base/use-case';
    import { ConsultRepository } from '../../repositories/consult.repository';
    import { DevelopmentNeuropsychologyResponseModel } from '../../models/consult/development-neuropsychology-response.model';
import { DevelopmentNeuropsychologyModel } from '../../models/consult/development-neuropsychology.model';

    export class InsertDevelopmentNeuropsychologyUseCase implements UseCase<DevelopmentNeuropsychologyModel, DevelopmentNeuropsychologyResponseModel> {
        constructor(private consult: ConsultRepository) { }
            execute(params:DevelopmentNeuropsychologyModel): Observable<DevelopmentNeuropsychologyResponseModel> {
        return this.consult.insertDevelopmentNeuropsychology(params);
        }
    }